import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import { Headers } from 'shared/constants/headers';
import { z } from 'zod';

export interface InitiateChallengeData {
  challengeContext: string;
  identityId: string;
}

// Define schema for challenge object
export const challengeSchema = z.object({
  challengeId: z.string(),
  challengeContext: z.string(),
  challengeType: z.string(),
  challengeState: z.string(),
});

// Define schema that matches InitiateChallengeResponse
const initiateChallengeResponseSchema = z.object({
  challenges: z.array(challengeSchema).optional(),
  errorCode: z
    .union([z.string(), z.number()])
    .transform((value) => Number(value))
    .optional(),
  message: z.string().optional(),
  title: z.string().optional(),
});

// Extract type from schema
export type InitiateChallengeResponse = z.infer<
  typeof initiateChallengeResponseSchema
>;

export default async function fetchInitiateChallenge(
  lambdaUrl: string,
  data: InitiateChallengeData,
  headers: Headers,
) {
  const response = await unauthenticatedFetch(
    `${lambdaUrl}/initiate-challenge`,
    {
      method: 'POST',
      cache: 'no-cache',
      body: JSON.stringify(data),
      headers,
    },
  );

  const result: unknown = await response.json();
  return initiateChallengeResponseSchema.parse(result);
}
